export default "__VITE_ASSET__Bj1giQ5u__"